import { useState } from "react";
import TrustBar from "../../components/feature/TrustBar";
import SectionPageHero from "../../components/feature/SectionPageHero";
import ProcessSection from "../home/components/ProcessSection";
import WhyChooseUs from "../home/components/WhyChooseUs";
import ServiceAreasSection from "../home/components/ServiceAreasSection";
import TestimonialsSection from "../home/components/TestimonialsSection";
import FinalCTASection from "../home/components/FinalCTASection";

const CONTACT_FAQS = [
  { id: 1, q: "What is the fastest way to reach Jerry's Plumbing?", a: "The fastest way is to call us directly at (817) 832-4968 for Arlington and DFW, or (972) 262-5113 for the Dallas area. For non-emergency requests, you can also fill out our online form and we'll respond within the hour during business hours." },
  { id: 2, q: "Do you offer same-day plumbing appointments?", a: "Yes — same-day appointments are available for most plumbing and heating service requests throughout DFW. Call us at (817) 832-4968 to check availability for your area and describe your issue so we can dispatch the right technician." },
  { id: 3, q: "How do I request a free plumbing estimate?", a: "You can request a free estimate by calling (817) 832-4968, emailing jph832@yahoo.com, or filling out our online contact form. We'll schedule an assessment at your property and provide a transparent written quote before any work begins." },
  { id: 4, q: "What should I tell you when I call?", a: "Have your address ready and describe the plumbing or heating issue as best you can — what symptoms you're seeing, when it started, and whether it's an emergency. The more detail you provide, the better equipped we'll be to help you quickly." },
  { id: 5, q: "Do you have a physical office location?", a: "Yes — Jerry's Plumbing, Heating & Welding is located at 440 Whitney St, Cedar Hill, TX 75104. We are a mobile service company and dispatch to your location throughout DFW. Call ahead before visiting." },
  { id: 6, q: "What are your hours of operation?", a: "We offer 24/7 emergency plumbing and heating services, 365 days a year. For standard non-emergency appointments, call us to schedule at a time that's convenient for you. We work to accommodate your schedule." },
];

export default function ContactPage() {
  const [submitted, setSubmitted] = useState(false);
  const [openId, setOpenId] = useState<number | null>(1);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as URLSearchParams);
    fetch("https://readdy.ai/api/form/d6va45dt4s7j0tv5icu0", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: data.toString(),
    }).then(() => { setSubmitted(true); form.reset(); });
  };

  return (
    <main className="pt-[100px]">
      {/* 1. Hero */}
      <SectionPageHero
        badge="Contact Jerry's — Available 24/7"
        headline={<>Contact Jerry&apos;s Plumbing &amp; <span className="text-[#E8500A]">Get Fast Service</span></>}
        subheadline="Call, email, or submit our form — we respond fast and are available 24/7 for plumbing and heating emergencies throughout the Dallas–Fort Worth metroplex."
        imageUrl="https://public.readdy.ai/ai/img_res/9420dbda180a1cf1ce97c554c7e2ea42.jpg"
        stats={[{ value: "24/7", label: "Emergency Line" }, { value: "1hr", label: "Response Time" }, { value: "Free", label: "Estimate" }]}
      />

      {/* 2. Trust Bar */}
      <TrustBar />

      {/* 3. Contact Info + Form (Adapted Content) */}
      <section className="bg-[#F8F7F4] py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-5 gap-10 items-start">
            {/* Contact info col */}
            <div className="lg:col-span-2 space-y-5">
              <div className="bg-[#0B1829] rounded-2xl p-7 text-white">
                <h2 className="font-black text-2xl mb-5" style={{ fontFamily: "'Barlow', sans-serif" }}>Contact Information</h2>
                <div className="space-y-5">
                  <div>
                    <p className="text-[#E8500A] text-xs font-bold tracking-widest uppercase mb-2">Address</p>
                    <a href="https://maps.app.goo.gl/oqw8JCNvgSRZngpEA" target="_blank" rel="noopener nofollow" className="flex items-start gap-2 text-gray-300 hover:text-white text-sm transition-colors">
                      <i className="ri-map-pin-2-fill text-[#E8500A] flex-shrink-0 mt-0.5" />440 Whitney St, Cedar Hill, TX 75104
                    </a>
                  </div>
                  <div>
                    <p className="text-[#E8500A] text-xs font-bold tracking-widest uppercase mb-2">Phone</p>
                    <a href="tel:8178324968" className="flex items-center gap-2 text-gray-300 hover:text-white text-sm mb-1.5 transition-colors">
                      <i className="ri-phone-fill text-[#E8500A]" />Arlington: <strong className="text-white ml-1">(817) 832-4968</strong>
                    </a>
                    <a href="tel:9722625113" className="flex items-center gap-2 text-gray-300 hover:text-white text-sm transition-colors">
                      <i className="ri-phone-fill text-[#E8500A]" />Dallas: <strong className="text-white ml-1">(972) 262-5113</strong>
                    </a>
                  </div>
                  <div>
                    <p className="text-[#E8500A] text-xs font-bold tracking-widest uppercase mb-2">Email</p>
                    <a href="mailto:jph832@yahoo.com" className="flex items-center gap-2 text-gray-300 hover:text-white text-sm transition-colors">
                      <i className="ri-mail-fill text-[#E8500A]" />jph832@yahoo.com
                    </a>
                  </div>
                  <div>
                    <p className="text-[#E8500A] text-xs font-bold tracking-widest uppercase mb-2">Hours</p>
                    <p className="text-white font-bold text-sm flex items-center gap-2"><i className="ri-time-fill text-[#E8500A]" />24/7 Emergency Service</p>
                  </div>
                  <div>
                    <p className="text-[#E8500A] text-xs font-bold tracking-widest uppercase mb-1">License</p>
                    <p className="text-gray-400 text-sm">TX Master Plumber LIC #M12160</p>
                  </div>
                </div>
              </div>
              <div className="rounded-2xl overflow-hidden h-52">
                <iframe title="Jerry's Plumbing location" src="https://maps.google.com/maps?q=440+Whitney+St,+Cedar+Hill,+TX+75104&t=&z=14&ie=UTF8&iwloc=&output=embed" className="w-full h-full border-0" loading="lazy" />
              </div>
              <div className="bg-[#E8500A] rounded-2xl p-6 text-center text-white">
                <i className="ri-alarm-warning-line text-3xl mb-2" />
                <h3 className="font-black text-lg mb-1" style={{ fontFamily: "'Barlow', sans-serif" }}>24/7 Emergency Service</h3>
                <p className="text-orange-100/80 text-sm mb-4">Plumbing emergencies never wait.</p>
                <a href="tel:8178324968" className="inline-flex items-center gap-2 bg-white text-[#E8500A] font-black px-6 py-2.5 rounded-lg text-sm whitespace-nowrap hover:bg-orange-50 transition-colors">
                  <i className="ri-phone-fill" /> Call Now
                </a>
              </div>
            </div>

            {/* Form col */}
            <div className="lg:col-span-3 bg-white rounded-2xl overflow-hidden border border-gray-100">
              <div className="bg-[#E8500A] px-8 py-5">
                <h2 className="font-black text-2xl text-white" style={{ fontFamily: "'Barlow', sans-serif" }}>Request a Free Estimate</h2>
                <p className="text-orange-100/80 text-xs mt-1">We&apos;ll be in touch within the hour.</p>
              </div>
              <div className="p-8">
                {submitted ? (
                  <div className="text-center py-10">
                    <div className="w-16 h-16 flex items-center justify-center bg-green-50 rounded-full mx-auto mb-4">
                      <i className="ri-check-line text-3xl text-green-600" />
                    </div>
                    <h3 className="font-black text-xl text-gray-900 mb-2" style={{ fontFamily: "'Barlow', sans-serif" }}>Request Submitted!</h3>
                    <p className="text-gray-500 mb-4">We&apos;ll reach out shortly. For urgent issues, call us directly.</p>
                    <a href="tel:8178324968" className="inline-flex items-center gap-2 bg-[#E8500A] text-white font-bold px-6 py-3 rounded-lg text-sm whitespace-nowrap">
                      <i className="ri-phone-fill" /> (817) 832-4968
                    </a>
                    <br />
                    <button onClick={() => setSubmitted(false)} className="mt-4 text-[#E8500A] text-sm font-semibold hover:underline cursor-pointer">Submit another request</button>
                  </div>
                ) : (
                  <form id="contact-page-form" data-readdy-form onSubmit={handleSubmit} className="grid grid-cols-2 gap-5">
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 mb-1.5" htmlFor="cp-first">First Name <span className="text-[#E8500A]">*</span></label>
                      <input id="cp-first" name="first_name" type="text" required placeholder="John" className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#E8500A] focus:ring-1 focus:ring-[#E8500A]" />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 mb-1.5" htmlFor="cp-last">Last Name</label>
                      <input id="cp-last" name="last_name" type="text" placeholder="Smith" className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#E8500A] focus:ring-1 focus:ring-[#E8500A]" />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 mb-1.5" htmlFor="cp-email">Email <span className="text-[#E8500A]">*</span></label>
                      <input id="cp-email" name="email" type="email" required placeholder="john@email.com" className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#E8500A] focus:ring-1 focus:ring-[#E8500A]" />
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-gray-700 mb-1.5" htmlFor="cp-phone">Phone <span className="text-[#E8500A]">*</span></label>
                      <input id="cp-phone" name="phone" type="tel" required placeholder="(817) 555-0123" className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#E8500A] focus:ring-1 focus:ring-[#E8500A]" />
                    </div>
                    <div className="col-span-2">
                      <label className="block text-xs font-semibold text-gray-700 mb-1.5" htmlFor="cp-city">City / Location</label>
                      <input id="cp-city" name="city" type="text" placeholder="e.g. Cedar Hill, Fort Worth, Arlington..." className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#E8500A] focus:ring-1 focus:ring-[#E8500A]" />
                    </div>
                    <div className="col-span-2">
                      <label className="block text-xs font-semibold text-gray-700 mb-1.5" htmlFor="cp-service">Service Needed</label>
                      <select id="cp-service" name="service" className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#E8500A] focus:ring-1 focus:ring-[#E8500A]">
                        <option value="">Select a service...</option>
                        <option>Plumbing Repair</option>
                        <option>Drain & Sewer Cleaning</option>
                        <option>Slab Leak Detection</option>
                        <option>Water Heater Repair/Replacement</option>
                        <option>Grease Trap Installation</option>
                        <option>Gas Line Repair</option>
                        <option>Welding Services</option>
                        <option>Plumbing Remodel</option>
                        <option>Emergency Service</option>
                        <option>Other</option>
                      </select>
                    </div>
                    <div className="col-span-2">
                      <label className="block text-xs font-semibold text-gray-700 mb-1.5" htmlFor="cp-message">Describe Your Issue</label>
                      <textarea id="cp-message" name="message" rows={4} maxLength={500} placeholder="Please describe your plumbing or heating issue..." className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#E8500A] focus:ring-1 focus:ring-[#E8500A] resize-none" />
                    </div>
                    <div className="col-span-2">
                      <button type="submit" className="w-full bg-[#E8500A] hover:bg-[#d14508] text-white font-bold py-4 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
                        Submit Service Request
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. AI Answer Block */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8">
            <div className="bg-[#F8F7F4] rounded-2xl p-8 border-l-4 border-[#E8500A]">
              <h2 className="font-black text-2xl text-gray-900 mb-3" style={{ fontFamily: "'Barlow', sans-serif" }}>How to Reach Jerry's Plumbing?</h2>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">Call (817) 832-4968 anytime — 24 hours a day, 7 days a week — for emergency and standard plumbing service across DFW. You can also email jph832@yahoo.com or use our online contact form for non-emergency requests and free estimate scheduling.</p>
            </div>
            <div className="bg-[#F8F7F4] rounded-2xl p-8 border-l-4 border-gray-200">
              <h2 className="font-black text-2xl text-gray-900 mb-3" style={{ fontFamily: "'Barlow', sans-serif" }}>What to Do in a Plumbing Emergency</h2>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">Shut off the main water valve immediately to stop flooding or water damage. For gas leaks, evacuate and call us plus your gas provider. Then call Jerry's at (817) 832-4968 — we&apos;ll dispatch a licensed technician to your location as quickly as possible, 24/7.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 5. Process */}
      <ProcessSection />

      {/* 6. Why Choose Us */}
      <WhyChooseUs />

      {/* 7. Service Areas */}
      <ServiceAreasSection />

      {/* 8. Testimonials */}
      <TestimonialsSection />

      {/* 9. FAQ */}
      <section className="bg-[#F8F7F4] py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-[#E8500A] font-bold text-xs tracking-widest uppercase mb-3">Contact FAQ</p>
            <h2 className="text-4xl font-black text-gray-900" style={{ fontFamily: "'Barlow', sans-serif" }}>Questions About Contacting Us</h2>
          </div>
          <dl className="space-y-3">
            {CONTACT_FAQS.map((faq) => (
              <div key={faq.id} className={`rounded-xl border overflow-hidden transition-all ${openId === faq.id ? "border-[#E8500A]/30 bg-orange-50/60" : "border-gray-200 bg-white hover:border-orange-200"}`}>
                <dt>
                  <button className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer" onClick={() => setOpenId(openId === faq.id ? null : faq.id)}>
                    <span className={`font-bold text-sm pr-4 leading-snug ${openId === faq.id ? "text-[#E8500A]" : "text-gray-900"}`}>{faq.q}</span>
                    <span className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 ${openId === faq.id ? "bg-[#E8500A] text-white" : "bg-gray-100 text-gray-500"}`}>
                      <i className={`text-sm ${openId === faq.id ? "ri-subtract-line" : "ri-add-line"}`} />
                    </span>
                  </button>
                </dt>
                {openId === faq.id && <dd className="px-6 pb-5"><p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p></dd>}
              </div>
            ))}
          </dl>
        </div>
      </section>

      {/* 10. Final CTA */}
      <FinalCTASection />
    </main>
  );
}
